import React, { useState, useRef } from "react";
import { Button, Card, CardContent, Box, Typography } from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  PlayArrow,
  Pause,
} from "@mui/icons-material";

const testimonials = [
  {
    id: 1,
    quote:
      "Employers are expecting AI fluency. It may not be on the job description, but it's going to be something that shows up somehow in the interview",
    author: "Daniel Shapero",
    title: "COO at LinkedIn",
    link: "https://www.youtube.com/embed/wKOdkit9dPQ?enablejsapi=1",
  },
  {
    id: 2,
    quote:
      "Nontechnical skills will be crucial in building resilient, AI-enhanced teams. As AI handles more routine tasks, companies will focus even more on developing human nontechnical skills like creativity and values-aligned thinking—qualities that machines simply can’t replicate",
    author: "Jennie Rogerson",
    title: " Global Head of People at Canva",
    link: "https://www.youtube.com/embed/wKOdkit9dPQ?enablejsapi=1",
  },
  {
    id: 3,
    quote:
      "The future of hiring lies in prioritising skills and adaptability. As business models evolve, credentials and past experiences will take a backseat to what individuals can truly achieve.",
    author: "Richard Lobo",
    title: "Chief People Officer at Tech Mahindra   ",
    link: "https://www.youtube.com/embed/wKOdkit9dPQ?enablejsapi=1",
  },
];

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const videoRef = useRef(null);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const toggleVideo = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const progress =
        (videoRef.current.currentTime / videoRef.current.duration) * 100;
      setProgress(progress);
    }
  };

  const handleProgressClick = (e) => {
    if (videoRef.current) {
      const rect = e.currentTarget.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const width = rect.width;
      const clickProgress = (clickX / width) * 100;
      const newTime = (clickProgress / 100) * videoRef.current.duration;
      videoRef.current.currentTime = newTime;
      setProgress(clickProgress);
    }
  };

  return (
    <Box
      sx={{
        py: 8,
        px: 2,
        maxWidth: "1200px",
        mx: "auto",
        mt: "100px",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
          fontWeight: "bold",
          textAlign: "center",
          mb: 8,
          color: "text.primary",
        }}
      >
        Our associations and what they say
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "2fr 3fr" },
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        {/* Video Player Section */}
        <Box>
          <Box sx={{ position: "relative" }}>
            {/* Video Player Container */}
            <Box
              sx={{
                backgroundColor: "black",
                borderRadius: "24px",
                p: 4,
                aspectRatio: "16/9",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <iframe
                // ref={videoRef}
                width="100%"
                height="100%"
                src={testimonials[currentTestimonial].link}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>

              {/* Play Button */}
              {/* <Button
                onClick={toggleVideo}
                size="large"
                sx={{
                  backgroundColor: "transparent",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                  border: 0,
                  p: 3,
                  borderRadius: "50%",
                  minWidth: "auto",
                }}
              >
                {isPlaying ? (
                  <Pause sx={{ width: 48, height: 48, color: "white" }} />
                ) : (
                  <PlayArrow
                    sx={{ width: 48, height: 48, color: "white", ml: 0.5 }}
                  />
                )}
              </Button> */}

              {/* Progress Bar */}
              {/* <Box
                sx={{
                  position: "absolute",
                  bottom: 24,
                  left: 24,
                  right: 24,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    height: 8,
                    borderRadius: "9999px",
                    cursor: "pointer",
                  }}
                  onClick={handleProgressClick}
                >
                  <Box
                    sx={{
                      backgroundColor: "white",
                      height: 8,
                      borderRadius: "9999px",
                      position: "relative",
                      width: `${progress}%`,
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: "50%",
                        transform: "translateX(50%) translateY(-50%)",
                        width: 16,
                        height: 16,
                        backgroundColor: "white",
                        borderRadius: "50%",
                      }}
                    ></Box>
                  </Box>
                </Box>
              </Box> */}
            </Box>

            {/* Video Navigation */}
            <Box
              sx={{ display: "flex", gap: 2, mt: 3, justifyContent: "center" }}
            >
              <Button
                size="large"
                sx={{
                  backgroundColor: "success.main",
                  "&:hover": { backgroundColor: "success.dark" },
                  color: "white",
                  borderRadius: "50%",
                  width: 48,
                  height: 48,
                  minWidth: "auto",
                  p: 0,
                }}
                onClick={prevTestimonial}
              >
                <ChevronLeft sx={{ width: 24, height: 24 }} />
              </Button>
              <Button
                size="large"
                sx={{
                  backgroundColor: "success.main",
                  "&:hover": { backgroundColor: "success.dark" },
                  color: "white",
                  borderRadius: "50%",
                  width: 48,
                  height: 48,
                  minWidth: "auto",
                  p: 0,
                }}
                onClick={nextTestimonial}
              >
                <ChevronRight sx={{ width: 24, height: 24 }} />
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Testimonials Section */}
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 3,
            }}
          >
            {/* Current Testimonial */}
            <Card sx={{ border: 0, boxShadow: "none", height: "auto" }}>
              <CardContent sx={{ p: 4 }}>
                <Typography
                  component="blockquote"
                  sx={{
                    fontSize: "1.125rem",
                    color: "text.primary",
                    mb: 4,
                    lineHeight: 1.75,
                  }}
                >
                  "{testimonials[currentTestimonial].quote}"
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "semibold",
                      color: "text.primary",
                      mb: 1,
                    }}
                  >
                    {testimonials[currentTestimonial].author}
                  </Typography>
                  <Typography
                    sx={{ color: "text.secondary", fontSize: "0.875rem" }}
                  >
                    {testimonials[currentTestimonial].title}
                  </Typography>
                </Box>
              </CardContent>
            </Card>

            {/* Next Testimonial Preview */}
            <Card sx={{ border: 0, boxShadow: "none", height: "auto" }}>
              <CardContent sx={{ p: 4 }}>
                <Typography
                  component="blockquote"
                  sx={{
                    fontSize: "1.125rem",
                    color: "text.primary",
                    mb: 4,
                    lineHeight: 1.75,
                  }}
                >
                  "
                  {
                    testimonials[(currentTestimonial + 1) % testimonials.length]
                      .quote
                  }
                  "
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "semibold",
                      color: "text.primary",
                      mb: 1,
                    }}
                  >
                    {
                      testimonials[
                        (currentTestimonial + 1) % testimonials.length
                      ].author
                    }
                  </Typography>
                  <Typography
                    sx={{ color: "text.secondary", fontSize: "0.875rem" }}
                  >
                    {
                      testimonials[
                        (currentTestimonial + 1) % testimonials.length
                      ].title
                    }
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* Testimonials Navigation */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 4,
              justifyContent: { xs: "center", md: "center" },
            }}
          >
            <Button
              size="large"
              sx={{
                backgroundColor: "success.main",
                "&:hover": { backgroundColor: "success.dark" },
                color: "white",
                borderRadius: "50%",
                width: 48,
                height: 48,
                minWidth: "auto",
                p: 0,
              }}
              onClick={prevTestimonial}
            >
              <ChevronLeft sx={{ width: 24, height: 24 }} />
            </Button>
            <Button
              size="large"
              sx={{
                backgroundColor: "success.main",
                "&:hover": { backgroundColor: "success.dark" },
                color: "white",
                borderRadius: "50%",
                width: 48,
                height: 48,
                minWidth: "auto",
                p: 0,
              }}
              onClick={nextTestimonial}
            >
              <ChevronRight sx={{ width: 24, height: 24 }} />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
